import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TYPES } from '../../reducer';

function availabilityLimitInspectors(inspectors, availability) {
  const ii = { ...inspectors };
  const availabilityByDate = {};
  for (let i in availability) {
    const a = availability[i];
    availabilityByDate[a.data.id] = availabilityByDate[a.data.id] ? [...availabilityByDate[a.data.id], a] : [a];
  }

  let jj = {};
  for (let id in ii) {
    jj[id] = { ...ii[id], availability: availabilityByDate[id] };
  }

  return jj;
}

export default function useAvailabilityFilter() {
  const dispatch = useDispatch();

  // Select needed parts
  const inspectors = useSelector(state => state.inspectors);
  const availability = useSelector(state => state.availability);
  const inspectorId = useSelector(state => state.inspector?.id);

  useEffect(
    function () {
      if (!inspectorId) return; // Guard clause

      const ii = availabilityLimitInspectors(inspectors, availability) || {};
      
      dispatch({
        type: TYPES.INSPECTOR_AVAILABILITY, 
        payload: ii[inspectorId] 
      });
    },
    [inspectors, inspectorId, availability, dispatch]
  );
}